import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ytngyu6w7q: FaireBrandEntity = {
  token: "b_ytngyu6w7q",
  type: "brand",
  name: "nomina",
  avatarUrl:
    "https://cdn.faire.com/fastly/c600da9c7c0827c3e509db6e1cbfb9093b4fe0309b234d21b4e7dc1c0e84b929.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3124b428e7ae7db39822480c9771d710c00b8ea469faa95306abfe46301c59e7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c600da9c7c0827c3e509db6e1cbfb9093b4fe0309b234d21b4e7dc1c0e84b929.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3124b428e7ae7db39822480c9771d710c00b8ea469faa95306abfe46301c59e7.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 131,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Purity Holds the Spark\n\nNOMINA is born from a simple idea — that true brilliance emerges when nothing unnecessary remains.\n\nCrafted in Japan, NOMINA begins with pristine natural spring water, sourced from deep within the country’s rich volcanic soil. Through a unique process, it’s infused with extra carbonation to awaken the senses — creating a sparkling water that’s clean, sharp, and astonishingly smooth.\n\nThis is more than just water, and more than just bubbles. It’s a moment of clarity — pure, invigorating, and alive.\n\nEvery sip marks a subtle shift — from noise to stillness, from routine to awareness. NOMINA is not for thirst, but for those moments when you seek focus, inspiration, and renewal.\n\nFrom Japan to the world, NOMINA captures the quiet power of purity — and the spark it holds within.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:06.156Z",
    importedBy: "entity-db-cli",
  },
};
